/* eslint-disable */
/* eslint-disable prettier/prettier */
import React from 'react';
import Icon from '@ant-design/icons';

const FacebookSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="18px"
      height="18px"
      viewBox="0 0 300 300"
    >
      <path
        fill="#ffffff"
        d="M113.98,105.863V79.989c0-19.276,2.875-32.639,8.624-40.078c10.481-13.19,24.521-19.783,42.107-19.783
            c10.146,0,19.191,0.422,27.143,1.266c7.949,0.846,13.443,1.772,16.486,2.791l4.567,1.013l-6.595,39.572
            c-7.441-2.03-14.711-3.046-21.816-3.046c-13.191,0-19.785,4.738-19.785,14.206v29.934h42.615l-2.535,39.062h-40.08v134.946H113.98
            V144.926H87.092v-39.062h26.888V105.863z"
      />
    </svg>
  );
};

export const FacebookIcon = (props) => (
  <Icon {...props} component={FacebookSvg} />
);

const GoogleWhiteSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="16px"
      height="16px"
      viewBox="0 0 24 24"
    >
      <path
        fill="#ffffff"
        d="M12.24 10.285V14.4h6.806c-.275 1.765-2.056 5.174-6.806 5.174-4.095 0-7.439-3.389-7.439-7.574s3.345-7.574 7.439-7.574c2.33 0 3.891.989 4.785 1.849l3.254-3.138C18.189 1.186 15.479 0 12.24 0c-6.635 0-12 5.365-12 12s5.365 12 12 12c6.926 0 11.52-4.869 11.52-11.726 0-.788-.085-1.39-.189-1.989H12.24z"
      ></path>
    </svg>
  );
};

export const GoogleIcon = (props) => (
  <Icon {...props} component={GoogleWhiteSvg} />
);
